/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasOperation } from '../../openapi/models/OasOperation';
import { Oas30Operation } from '../../openapi/v3/models/Oas30Operation';
import { NewRequestBodyCommand } from './NewRequestBodyCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewRequestBodyCommand
 * @class
 */
export class NewRequestBodyCommand_30 extends NewRequestBodyCommand {
    public constructor(operation? : any) {
        if(((operation != null && operation instanceof <any>OasOperation) || operation === null)) {
            let __args = arguments;
            super(operation);
        } else if(operation === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand#hasRequestBody(io.apicurio.datamodels.openapi.models.OasOperation)
     * @param {OasOperation} operation
     * @return {boolean}
     */
    hasRequestBody(operation : OasOperation) : boolean {
        let op30 : Oas30Operation = <Oas30Operation>operation;
        return !this.isNullOrUndefined(op30.requestBody);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand#doCreateRequestBody(io.apicurio.datamodels.openapi.models.OasOperation)
     * @param {OasOperation} operation
     */
    doCreateRequestBody(operation : OasOperation) {
        let op30 : Oas30Operation = <Oas30Operation>operation;
        op30.requestBody = op30.createRequestBody();
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand#doRemoveRequestBody(io.apicurio.datamodels.openapi.models.OasOperation)
     * @param {OasOperation} operation
     */
    doRemoveRequestBody(operation : OasOperation) {
        let op30 : Oas30Operation = <Oas30Operation>operation;
        op30.requestBody = null;
    }
}
NewRequestBodyCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.NewRequestBodyCommand_30";
NewRequestBodyCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




